import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
// import heroic from '../assets/sponsors/heroic-stamp-color.png';
import lansing from '../assets/sponsors/sparrow-lansing.png';
import phx from '../assets/sponsors/phoenix-hospital.jpg';
import mel from '../assets/sponsors/beaumontchildrenshospital.png';

const ONE_MINUTE_MS = 60000;
const list = [lansing, phx, mel];

export default function Sponsor(props) {
	const { className } = props;

	const [src, setSrc] = useState(lansing);

	useEffect(() => {
		let index = Math.floor(Math.random() * list.length);

		const upkeep = () => {
			index = (index + 1) % list.length;
			setSrc(list[index]);
		};

		const timer = setInterval(upkeep, ONE_MINUTE_MS);
		upkeep();

		return () => {
			clearInterval(timer);
		};
	}, []);

	return (
		<div
			className={className}
			style={{
				backgroundImage: `url(${src})`,
				backgroundSize: 'contain',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
			}}
		/>
	);
}

Sponsor.defaultProps = {
	className: undefined,
};

Sponsor.propTypes = {
	className: propTypes.string,
	// type: propTypes.string.isRequired,
};
